import script from "./PhoneMyGit.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMyGit.vue?vue&type=script&setup=true&lang=js"

import "./PhoneMyGit.vue?vue&type=style&index=0&id=3a6cf9ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a6cf9ff"]])

export default __exports__